import { getEnvironment } from '../env/env';
import { fetchRequest } from './FetchRequest';
import { API_VERSION, PATH_AUTH_API } from 'src/constants/api-routes';

interface GoogleTokens {
  access_token?: string;
  [key: string]: unknown;
}

const signInWithGoogle = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signInWithGoogle: async (code: string): Promise<any> => {
    const environment = await getEnvironment();
    const getTokenURL = `https://oauth2.googleapis.com/token`;
    const data = {
      code: decodeURIComponent(code),
      client_id: environment.APP_GOOGLE_OAUTH_CLIENT_ID,
      client_secret: environment.APP_GOOGLE_OAUTH_CLIENT_SECRET,
      redirect_uri: decodeURIComponent(environment.APP_REDIRECT_URI),
      access_type: 'offline',
      grant_type: 'authorization_code',
    };

    try {
      const tokens = await fetchRequest('POST', getTokenURL, data);
      localStorage.setItem('tokens', JSON.stringify(tokens));
    } catch (error) {
      return new Error(String(error));
    }

    try {
      const raw = localStorage.getItem('tokens');
      const tokens: GoogleTokens | null = raw ? JSON.parse(raw) : null;

      if (tokens && tokens.access_token) {
        const loginResult = await fetchRequest(
          'POST',
          `${environment.APP_SSO_BASE_URL}/${API_VERSION.V1}/${PATH_AUTH_API.TOKEN_GOOGLE}`,
          {
            token: tokens.access_token,
          },
        );

        return loginResult;
      }
    } catch (error: unknown) {
      const err = error as { code?: number; text?: string };
      if (err.code === 403 && err.text === 'User already authenticated!') {
        return { success: true };
      } else {
        localStorage.removeItem('tokens');
        return new Error(JSON.stringify(err.text));
      }
    }
  },
};

export { signInWithGoogle };
